module.exports = __webpack_public_path__ + "static/media/no-results-employer-search.9cc1063c.svg";